import { message } from 'antd'
import i18n from 'i18next'

export const onSetDefaultBudget = ({
  setDefaultBudget,
  setShowScreenSuccess,
  sendUserDataToGTM,
}) => {
  setDefaultBudget().then(() => {
    setShowScreenSuccess(null)
    sendUserDataToGTM()
    message.success(i18n.t('FEEDBACK_SAVE_CHANGES_SUCCES'), 8)
  })
}
